import { Content } from '../../data-layer/posts/types';
import { buildPublicUrl } from '../../utils/buildUrl';

export const toPostContentModel = (contents: Content[]): Content<'model'>[] =>
    contents.map((content) => {
        if (content.type === 'image') {
            return {
                id: content.id,
                type: 'image',
                media: content.media,
            };
        }

        return {
            id: content.id,
            type: 'video',
            media: content.media.map((file) => ({
                url: file.url,
                width: file.width,
                height: file.height,
                durationMs: file.duration_ms,
                firstFrameHash: file.first_frame_hash,
                firstFrameUrl: file.first_frame_url ?? buildPublicUrl('/images/firstFrame.png'),
                previewFormats: file.preview_formats,
                streams: file.streams?.map((stream) => ({
                    stream: stream.url,
                    streamType: stream.stream_type,
                })),
                uuid: file.strm_content_id,
            })),
        };
    });
